<template>
    <section id="IndexComponent">
        <v-parallax dark src="@/assets/img/bg.png" height="750" width="100%">
            <v-row align="center" justify="center">
                <v-col cols="12">
                    <v-container>
                      <center>
                        <v-row align="center" justify="center">
                          <v-col cols="12" md="8">
                              <h3 class="display-2 font-weight-bold mb-4" id="firstname" style="color:#263238">José Santiago</h3>
                              <hr style="width:50%">
                              <h1 id="subtitle" style="color:#263238">Desarrollador Web</h1>
                          </v-col>
                          <v-col cols="12" md="4" class="center-text">
                              <v-img  :src="avatar" id="avatarss"/>
                          </v-col>
                      </v-row>
                      </center>
                    </v-container>
                </v-col>
            </v-row>
                  <div class="svg-border-waves text-white" height="100px">
                        <v-img src="@/assets/img/borderWaves.svg" />
                    </div>
        </v-parallax>
            <div class="svg-border-waves">
                <img src="~@/assets/img/wave2.svg" />
                </div>
    </section>
</template>

<script>
export default {
    name:'IndexComponent',
    data:()=>({
        avatar:require('../../assets/img/avatar.png')
    })
}
</script>

<style>
#IndexComponent {
  z-index: 0;
}
.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#hero {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}
section {
  position: relative;
}
.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
#avatarss{
  width: 80%;

}
</style>